import { render, staticRenderFns } from "./Gantt.vue?vue&type=template&id=7a13afdc"
import script from "./Gantt.vue?vue&type=script&lang=js"
export * from "./Gantt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports